var $cf7ebbe00c623346$exports = {};
// logga ut-knapp
const $cf7ebbe00c623346$var$logOutBtnEl = document.getElementById("logoutbtn");
$cf7ebbe00c623346$var$logOutBtnEl.addEventListener("click", $cf7ebbe00c623346$var$logout);
function $cf7ebbe00c623346$var$logout() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    window.location.href = "index.html";
}
const $cf7ebbe00c623346$var$url = "https://pizzaapi-kzs1.onrender.com/booking" //URL till mitt API
;
/* Hämta bokningarna */ window.onload = $cf7ebbe00c623346$var$init;
async function $cf7ebbe00c623346$var$init() {
    const token = localStorage.getItem("token");
    const response = await fetch($cf7ebbe00c623346$var$url, {
        headers: {
            "Authorization": "Bearer " + token
        }
    });
    const data = await response.json();
    console.log(data);
    $cf7ebbe00c623346$var$displayBookings(data);
}
//skriv ut bokningarna
function $cf7ebbe00c623346$var$displayBookings(data) {
    const bookingListEl = document.getElementById("bookingList");
    data.forEach((e)=>{
        const bookingItem = document.createElement("div");
        bookingItem.classList = "bookingItem";
        bookingItem.innerHTML += `<h4 class="name">G\xe4stens namn: ${e.name}</h4>
        <p class="phonenumber">Telefonnummer: ${e.phonenumber}</p>
        <p class="numberOfGuests">Antal g\xe4ster: ${e.numberOfGuests}</p> 
        <p class="date">Datum: ${e.date}</p> 
        <p class="created">Skapad: ${e.created}</p> 
        </div>`;
        const deleteBookingBtn = document.createElement("input");
        deleteBookingBtn.type = "button";
        deleteBookingBtn.value = "Radera bokning";
        deleteBookingBtn.classList = "deleteBtn button";
        deleteBookingBtn.addEventListener("click", ()=>{
            $cf7ebbe00c623346$var$deleteBooking(e._id);
        });
        bookingListEl.appendChild(bookingItem);
        bookingItem.appendChild(deleteBookingBtn);
    });
}
//radera bokingarna
async function $cf7ebbe00c623346$var$deleteBooking(id) {
    const token = localStorage.getItem("token");
    const response = await fetch($cf7ebbe00c623346$var$url + "/" + id, {
        method: "DELETE",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "Application/json"
        }
    });
    const data = await response.json();
    console.log(data);
    if (data.error) ;
    else /* status.innerHTML = `${data.message}`; */ location.reload();
}


//# sourceMappingURL=admin-bookings.25b0f473.js.map
